export default "__VITE_ASSET__Bb8RcrLs__"